import Icon from '@ant-design/icons';

const Powerpoint = () => (
   <svg viewBox="0 0 48 48" width="1em" height="1em">
      <path fill="#d35230" d="M8,24c0,9.941,8.059,18,18,18s18-8.059,18-18H26H8z" />
      <path fill="#ff8f6b" d="M26,6v18h18C44,14.059,35.941,6,26,6z" />
      <path fill="#ed6c47" d="M26,6C16.059,6,8,14.059,8,24h18V6z" />
      <path
         d="M26,16.681C26,14.648,24.352,13,22.319,13H11.774C9.417,16.044,8,19.852,8,24	c0,5.116,2.145,9.723,5.571,13h8.747C24.352,37,26,35.352,26,33.319V16.681z"
         opacity=".05"
      />
      <path
         d="M22.213,13.333H11.525C9.32,16.321,8,20.002,8,24c0,4.617,1.753,8.814,4.611,12h9.602	c1.724,0,3.121-1.397,3.121-3.121V16.454C25.333,14.731,23.936,13.333,22.213,13.333z"
         opacity=".07"
      />
      <path
         d="M22.106,13.667H11.276C9.218,16.593,8,20.151,8,24c0,4.148,1.417,7.956,3.774,11h10.332	c1.414,0,2.56-1.146,2.56-2.56V16.227C24.667,14.813,23.52,13.667,22.106,13.667z"
         opacity=".09"
      />
      <linearGradient
         id="N~uyq1CljjkKMh72IFt0Fa"
         x1="4.586"
         x2="22.77"
         y1="14.586"
         y2="32.77"
         gradientUnits="userSpaceOnUse"
      >
         <stop offset="0" stopColor="#ca4e2a" />
         <stop offset="1" stopColor="#b63016" />
      </linearGradient>
      <path
         fill="url(#N~uyq1CljjkKMh72IFt0Fa)"
         d="M22,34H6c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16	C24,33.105,23.105,34,22,34z"
      />
      <path
         fill="#fff"
         d="M14.673,19.012H10v10h2.024v-3.521H14.3c1.876,0,3.397-1.521,3.397-3.397v-0.058	C17.697,20.366,16.343,19.012,14.673,19.012z M15.57,22.358c0,0.859-0.697,1.556-1.556,1.556h-1.99v-3.325h1.99	c0.859,0,1.556,0.697,1.556,1.556V22.358z"
      />
   </svg>
);

const PptIcon = (props) => <Icon component={Powerpoint} {...props} />;
export default PptIcon;
